import { siteData } from '@/mocks/siteData';

const ICON_BG_COLORS = [
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-600',
  'bg-secondary-100 text-secondary-600',
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-600',
  'bg-secondary-100 text-secondary-600',
  'bg-primary-100 text-primary-600',
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-label mb-3">
            <i className="ri-folder-line"></i>专题合集
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            吃瓜专题 · 一站式索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            按话题分类浏览，轻松找到你感兴趣的爆料内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {siteData.indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-2xl hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className={`shrink-0 w-10 h-10 flex items-center justify-center rounded-xl ${ICON_BG_COLORS[(item.id - 1) % ICON_BG_COLORS.length]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-label text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="shrink-0 text-[10px] font-label px-2 py-0.5 rounded-full bg-background-100 text-foreground-500 ml-2">
                    {item.count}篇
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}